"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ovindoli": {
    "36a1be22": [{
      "hkey": "136b2a83",
      "slug": "casalmartino",
      "name": "Casalmartino",
      "primary": true,
      "skipSearch": false
    }],
    "casal-martino": [{
      "hkey": "136b2a83",
      "slug": "casalmartino",
      "name": "Casalmartino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;